var _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIntransitMarker(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 10.5,
    r: 4.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0833 10.291C14.0833 10.8893 13.5983 11.3743 13 11.3743C12.4017 11.3743 11.9167 10.8893 11.9167 10.291C11.9167 9.69271 12.4017 9.20768 13 9.20768C13.5983 9.20768 14.0833 9.69271 14.0833 10.291Z",
    fill: "#58CCA1",
    stroke: "#379270",
    strokeWidth: 1.08333
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3807 23.1379L13.3659 23.149L13.3518 23.1611C13.2536 23.245 13.1288 23.2911 12.9997 23.2911C12.871 23.2911 12.7465 23.2452 12.6485 23.1618C12.482 23.0175 10.5274 21.3237 8.6148 18.9409C6.67487 16.5241 4.87584 13.5166 4.87468 10.7487C4.89679 8.60893 5.76217 6.56421 7.28294 5.05864C8.80436 3.55244 10.8588 2.70758 12.9996 2.70768H12.9997C15.1406 2.70758 17.195 3.55244 18.7164 5.05864C20.2372 6.56422 21.1026 8.60895 21.1247 10.7487C21.1235 13.5177 19.3367 16.5257 17.4043 18.9416C16.4492 20.1356 15.4811 21.1575 14.7281 21.8984C14.3518 22.2686 14.0304 22.5675 13.7925 22.7815C13.6735 22.8886 13.5761 22.9739 13.5037 23.0358C13.4674 23.0668 13.4381 23.0914 13.416 23.1096L13.3897 23.1309C13.3834 23.1359 13.3807 23.1379 13.3807 23.1379ZM10.5922 13.8941C11.3048 14.3702 12.1426 14.6243 12.9997 14.6243C14.1489 14.6243 15.2511 14.1678 16.0638 13.3551C16.8765 12.5425 17.333 11.4403 17.333 10.291C17.333 9.43396 17.0789 8.59616 16.6027 7.88354C16.1266 7.17093 15.4498 6.61552 14.658 6.28754C13.8662 5.95956 12.9949 5.87374 12.1543 6.04095C11.3137 6.20815 10.5416 6.62086 9.93555 7.22689C9.32952 7.83291 8.91681 8.60504 8.7496 9.44562C8.5824 10.2862 8.66822 11.1575 8.9962 11.9493C9.32418 12.7411 9.87959 13.4179 10.5922 13.8941Z",
    fill: "#58CCA1",
    stroke: "#379270",
    strokeWidth: 1.08333
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntransitMarker);
export default __webpack_public_path__ + "static/media/intransit-marker.7c50264dca5c6733597de527518a0c42.svg";
export { ForwardRef as ReactComponent };